module.exports = __webpack_public_path__ + "static/key-8157a49323052fac98f25ab76381e8ff.png";